<template>
	<div class="main-table">
		<div class="main-table-box">
			<el-table
				ref="table"
				class="grid-content"
				:data="tableData"
				border
				stripe
				:summary-method="getSummaries"
				show-summary
				:height="tableHeight"
				@row-dblclick='rowClick'
			>
				<el-table-column
					label-class-name="column-index"
					label="序号"
					type="index"
					width="50"
					align="center">
				</el-table-column>
				<el-table-column
					prop="stockDate"
					label="日期"
					align="center"
					width="110">
				</el-table-column>
				<el-table-column
					prop="customername"
					label="商品名称/编号"
					align="center"
					min-width="120">
					<template slot-scope="scope">
						<el-popover
							placement="bottom-start"
							trigger="hover">
							<div>
								<div>商品名称：{{scope.row.productName}}</div>
								<div>商品编号：{{scope.row.productCode}}</div>
								<div>规格名称：{{scope.row.productAttrplanName}}</div>
								<div>规格编号：{{scope.row.productAttrplanCode}}</div>
								<div>条形码：{{scope.row.barCode}}</div>
							</div>
							<div slot="reference">
								<div>{{scope.row.productName}}</div>
								<div class="text-code">{{scope.row.productCode}}</div>
							</div>
						</el-popover>
					</template>
				</el-table-column>
				<el-table-column
					prop="productname"
					label="规格名称/编号"
					align="center"
					min-width="130">
					<template slot-scope="scope">
						<el-popover
							placement="bottom-start"
							trigger="hover">
							<div>
								<div>商品名称：{{scope.row.productName}}</div>
								<div>商品编号：{{scope.row.productCode}}</div>
								<div>规格名称：{{scope.row.productAttrplanName}}</div>
								<div>规格编号：{{scope.row.productAttrplanCode}}</div>
								<div>条形码：{{scope.row.barCode}}</div>
							</div>
							<div slot="reference">
								<div>{{scope.row.productAttrplanName}}</div>
								<div class="text-code">{{scope.row.productAttrplanCode}}</div>
							</div>
						</el-popover>
					</template>
				</el-table-column>
				<el-table-column
					prop="stockType"
					label="类型"
					align="center"
					min-width="120">
					<template slot-scope="scope">
						<div v-if="scope.row.stockType === 0" style="color:#5FAA67">入库 - {{scope.row.stockTypeName}}</div>
						<div v-else style="color:#D14354">出库 - {{scope.row.stockTypeName}}</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="orderNumber"
					label="关联"
					align="center"
					min-width="130">
					<template slot-scope="scope">
						<div class="under-num" @click="goOrderDetail(scope.row)" v-if="scope.row.orderNumber">{{scope.row.orderNumber}}</div>
						<div class="under-num" @click="goRefundOrderDetail(scope.row)" v-else-if="scope.row.refundOrderNumber">{{scope.row.refundOrderNumber}}</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="shopName"
					label="销售门店"
					align="center"
					min-width="130">
				</el-table-column>
				<el-table-column
					prop="inventory"
					label="库存量（前）"
					align="center"
					min-width="130">
					<template slot="header">
						<div class="title-box">库存量（前）
							<el-tooltip class="item" effect="dark" content="出入库前记录的库存数量" placement="top-start">
								<img src="~/images/icon/tooltip-icon.png" class="spec-title">
							</el-tooltip>
						</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="productQuantity"
					label="数量"
					align="center"
					min-width="110">
					<template slot-scope="scope">
						<div style="color:#5FAA67" v-if="scope.row.stockType === 0">+{{scope.row.productQuantity}}</div>
						<div style="color:#D14354" v-else>-{{scope.row.productQuantity}}</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="inventoryafter"
					label="库存量（后）"
					align="center"
					min-width="130">
					<template slot="header">
						<div class="title-box">库存量（后）
							<el-tooltip class="item" effect="dark" content="出入库后记录的库存数量" placement="top-start">
								<img src="~/images/icon/tooltip-icon.png" class="spec-title">
							</el-tooltip>
						</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="productPrice"
					label="单价"
					align="center">
				</el-table-column>
				<el-table-column
					prop="totalMoney"
					label="合计金额"
					align="center"
					min-width="110">
				</el-table-column>
				<el-table-column
					prop="stockOthersName"
					label="对方"
					align="center">
				</el-table-column>
				<el-table-column
					prop="giftFlag"
					label="赠送"
					align="center"
					width="90">
					<template slot-scope="scope">
						<div>{{scope.row.giftFlag ? '是' : '否'}}</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="url"
					label="附件"
					align="center"
					min-width="120">
					<template slot-scope="scope">
						<div class="under-num" v-if="scope.row.stockDocumentCount === 1">
							<a :href="'https://fxscms.oss-cn-beijing.aliyuncs.com' + scope.row.url" target="_blank">{{scope.row.fileName}}</a>
						</div>
						<el-popover
							placement="bottom-start"
							v-if="scope.row.stockDocumentCount > 1"
							@show="getAppendix(scope.row.id)"
							trigger="click"
							v-model="scope.row.docVisible">
							<div style="line-height:25px">
								<div>附件下载<i class="el-icon-close" style="float: right;cursor:pointer" @click="scope.row.docVisible = false"></i></div>
								<div class="under-num" v-for="item in documentList" :key="item.id" style="justify-content:start">
									<a :href="'https://fxscms.oss-cn-beijing.aliyuncs.com' + item.url" target="_blank">{{item.fileName}}</a>
								</div>
							</div>
							<div slot="reference">
								<div class="under-num" v-if="scope.row.fileName.length <= 10">{{scope.row.fileName}} 等{{scope.row.stockDocumentCount}}个</div>
								<div class="under-num" v-else>{{scope.row.fileName.substring(0,10)}}... 等{{scope.row.stockDocumentCount}}个</div>
							</div>
						</el-popover>
					</template>
				</el-table-column>
				<el-table-column
					prop="memo"
					label="备注"
					align="center"
					min-width="110">
					<template slot-scope="scope">
						<div v-if="scope.row.memo.length <= 10">{{scope.row.memo}}</div>
						<div v-else :title="scope.row.memo">{{scope.row.memo.substring(0,10) + '...'}}</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="userName"
					label="操作人"
					align="center">
				</el-table-column>
				<el-table-column label="操作" width="150" align="center">
					<template slot-scope="scope">
						<el-button type='text' size="mini" @click="godetail(scope.row.id)" v-if="AuthorityList['13_0001_0003_00'] && !scope.row.autoType">编辑</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<el-pagination
			@size-change="handleSizeChange"
			@current-change="handlePageChange"
			:current-page="pagination.page"
			:page-sizes="[20, 40, 60, 100, 300]"
			:page-size="pagination.size"
			layout="total, sizes, prev, pager, next, jumper"
			:total="totalCount">
		</el-pagination>
	</div>
</template>

<script>
export default {
	name: 'mainTable',
	props: {
		tableData: {
			type: Array
		},
		totalCount: {
			type: Number
		},
		size: {
			type: Number,
			default: 20
		},
		page: {
			type: Number,
			default: 1
		},
		AuthorityList: {
			type: Object
		},
		sumProductQuantity: Number,
		sumTotalMoney: String
	},
	data () {
		return {
			tableHeight: '100%',
			pagination: {
				page: this.page,
				size: this.size
			},
			documentList: []
		}
	},
	watch: {
		tableData: {
			handler (val) {
				this.$nextTick(() => {
					this.$refs['table'].doLayout()
				})
			}
		},
		page: {
			handler (val) {
				this.pagination.page = val
			}
		}
	},
	created () {
	},
	methods: {
		getSummaries (param) {
			const { columns, data } = param
			const sums = []
			console.log(columns, data)
			columns.forEach((column, index) => {
				sums[index] = ''
				if (index === 1) {
					sums[index] = '搜索结果合计:'
				}
				if (index === 8) {
					sums[index] = this.sumProductQuantity
				}
				if (index === 11) {
					sums[index] = this.sumTotalMoney + '元'
				}
			})
			return sums
		},
		// 获取附件
		getAppendix (id) {
			let params = {
				id: id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/stock/stockdocument/list`,
				data: params
			}).then(res => {
				if (res.result) {
					this.documentList = res.data
				} else {
					this.$message.error(res.msg)
				}
			}).catch(error => {
				this.$message.error(error.msg)
			})
		},
		rowClick (row, column, event) {
			if (this.AuthorityList['13_0001_0003_00'] && !row.autoType) {
				this.$router.push({ path: '/main/editStorage', query: { id: row.id } })
			}
		},
		// 跳详情
		godetail (id) {
			this.$router.push({ path: '/main/editStorage', query: { id: id } })
		},
		// 跳订单
		goOrderDetail (row) {
			let orderParams = {}
			orderParams.orderId = row.orderId
			switch (row.orderStatus) {
			case 0:
				orderParams.billState = '待付款'
				break
			case 1:
				orderParams.billState = '待接单'
				break
			case 2:
				orderParams.billState = '待发货'
				break
			case 3:
				orderParams.billState = '待收货'
				break
			case 4:
				orderParams.billState = '已完成'
				break
			case 5:
				orderParams.billState = '已取消'
				break
			}
			window.sessionStorage.setItem('orderInfo', JSON.stringify(orderParams))
			let tabInfo = {}
			tabInfo.active = orderParams.billState
			tabInfo.isSellerpull = false
			tabInfo.orderStatus = row.orderStatus
			window.sessionStorage.setItem('tabInfo', JSON.stringify(tabInfo))
			this.$fxGoBlank('/blankdetail', this.$router)
		},
		// 跳退单
		goRefundOrderDetail (row) {
			let a = JSON.stringify(row)
			window.sessionStorage.setItem('refundOrderParams', a)
			this.$fxGoBlank('/blankRefundDetail', this.$router)
		},
		handleSizeChange (value) {
			this.pagination.size = value
			this.$emit('handleSize', value)
		},
		handlePageChange (value) {
			this.pagination.page = value
			this.$emit('handlePage', value)
		}
	}
}
</script>

<style lang="stylus" scoped>
.main-table {
	display flex
	flex: 1
	flex-direction: column
	min-height: 0
	.main-table-box {
		flex: 1
		width: 100%
		box-sizing: border-box;
		overflow: hidden
		overflow-y: auto;
		display flex
		flex-direction: column
		.text-code {
			color: #999;
			font-size:12px
		}
	}
}
</style>
<style lang="stylus">
.under-num {
	cursor :pointer;
	color: var(--fx-primary-color);
	display: flex;
	justify-content: center;
	align-items: center;
}
.main-table {
	.el-dialog {
		border-radius: 4px
	}
	.el-dialog__title {
		padding-left 10px
		border-left 5px solid var(--fx-primary-color)
	}
	.el-dialog__body {
		padding-top: 10px
	}
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
	.el-radio-group {
		display flex
		flex-direction: column
		padding: 0 15px 20px
		.el-radio {
			line-height: 30px
		}
	}
	.under-num1 {
		color: var(--fx-primary-color);
		display: flex;
		align-items: center;
		span {
			cursor :pointer;
		}
		.return-icon {
			margin-left :5px;
			font-size :10px;
			width: 20px;
			height: 18px;
			line-height: 16px;
			color :#EC4141;
			border :1px solid #EC4141;
			border-radius :5px;
			flex-shrink: 0
		}
	}
	.title-box {
		display: flex;
		justify-content: center;
		align-items: center;
		.spec-title {
			width: 14px;
			height: 14px;
			cursor: pointer;
			margin: -1px 0 0 4px;
		}
	}
}
</style>
